import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// Configure the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

function App() {
  const [file, setFile] = useState(null);
  const [textToReplace, setTextToReplace] = useState("");
  const [replacementText, setReplacementText] = useState("");
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState("edit"); // 'edit' or 'convert'
  const [numPages, setNumPages] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a file.");
      return;
    }

    if (action === "edit" && !textToReplace) {
      alert("Please enter text to replace.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    let url = "";
    let downloadName = "";

    if (action === "edit") {
      formData.append("textToReplace", textToReplace);
      formData.append("replacementText", replacementText);
      url = "/api/edit_pdf";
      downloadName = "edited.pdf";
    } else {
      url = "/api/convert_to_word";
      downloadName = "converted.docx";
    }

    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Server returned ${res.status}: ${text}`);
      }

      const contentType = res.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const data = await res.json();
        alert("Error: " + data.error);
      } else {
        const blob = await res.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = downloadName;
        link.click();
        URL.revokeObjectURL(downloadUrl);
      }
    } catch (err) {
      console.error("Request failed:", err);
      alert("Request failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>PDF Tool</h1>
      <div>
        <label>
          <input
            type="radio"
            value="edit"
            checked={action === "edit"}
            onChange={() => setAction("edit")}
          />
          Find and Replace
        </label>
        <label style={{ marginLeft: 10 }}>
          <input
            type="radio"
            value="convert"
            checked={action === "convert"}
            onChange={() => setAction("convert")}
          />
          Convert to Word
        </label>
      </div>

      <hr style={{ margin: "20px 0" }} />

      <input type="file" accept="application/pdf" onChange={handleFileChange} />

      {action === "edit" && (
        <div>
          <div>
            <input
              type="text"
              placeholder="Text to find"
              value={textToReplace}
              onChange={(e) => setTextToReplace(e.target.value)}
              style={{ marginTop: 10, width: 200 }}
            />
          </div>
          <div>
            <input
              type="text"
              placeholder="Replace with"
              value={replacementText}
              onChange={(e) => setReplacementText(e.target.value)}
              style={{ marginTop: 10, width: 200 }}
            />
          </div>
        </div>
      )}

      <button
        style={{ marginTop: 10 }}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading
          ? "Processing..."
          : action === "edit"
          ? "Edit PDF"
          : "Convert to Word"}
      </button>

      {file && (
        <div style={{ marginTop: 20 }}>
          <h2>Preview</h2>
          <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        </div>
      )}
    </div>
  );
}

export default App;